export default "__VITE_ASSET__34EWPvt7__"